<template>
  <div class="addform">
    <drag-modal :visible="visible" @cancel="cancel" title="新增用户" width="860px">
      <a-form-model ref="addForm" :model="form" :rules="rules" hideRequiredMark :label-col="{ span: 4 }"
        :wrapper-col="{ span: 20 }" class="flexbox">
        <a-form-model-item label="账号名称：" prop="uname">
          <a-input v-model="form.uname" placeholder="请设置账号名称" :maxLength="8" style="width: 100%" />
        </a-form-model-item>
        <a-form-model-item label="账号密码：" prop="password">
          <a-input v-model="form.password" type="password" placeholder="请设置密码" style="width: 100%" />
        </a-form-model-item>
        <a-form-model-item label="手机号：" prop="phone">
          <a-input v-model="form.phone" placeholder="请设置手机号" style="width: 100%" />
        </a-form-model-item>
        <!-- <a-form-model-item label="所属公司" prop="title">
          <a-select show-search v-model="form.title" placeholder="请选择" :allowClear="true"
            :default-active-first-option="false" :show-arrow="false" :filter-option="false" :not-found-content="null"
            @search="handleSearch">
            <a-select-option v-for="item in comList" :key="item.title" :value="item.title">{{ item.title
            }}</a-select-option>
          </a-select>
        </a-form-model-item> -->
        <a-form-model-item label="所属机构" prop="user_group_id">
          <a-select show-search v-model="form.user_group_id" placeholder="请选择" :allowClear="true"
            :default-active-first-option="false" :show-arrow="false" :filter-option="false" :not-found-content="null">
            <a-select-option v-for="item in user_group" :key="item.id" :value="item.id">{{ item.title
            }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="关联原告：" prop="accuser">
          <a-select mode="multiple" allowClear v-model="form.accuser" @change="accuserChange" @select="accuserSelect"
            placeholder="请选择" style="width: 100%" :maxTagCount="1" :maxTagTextLength="5">
            <a-select-option value="-1">全部</a-select-option>
            <a-select-option v-for="item in accuserList" :key="item.title" :value="item.id">{{ item.title
            }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="账号状态：" prop="audit">
          <a-switch checked-children="启用" un-checked-children="禁用" default-checked v-model="form.audit" />
        </a-form-model-item>
        <a-form-model-item label="内部用户：" prop="is_inner_user">
          <a-switch checked-children="是" un-checked-children="否" default-checked v-model="form.is_inner_user" />
        </a-form-model-item>
        <a-form-model-item style="text-align: center" :wrapper-col="{ span: 24 }">
          <a-button type="primary" @click="onSubmit()">提交</a-button>
          <a-button class="cancel" type="primary" @click="cancel()" style="
                margin-left: 30px;
                background-color: #b2c9e1;
                border-color: #b2c9e1;
              ">取消</a-button>
        </a-form-model-item>
      </a-form-model>
    </drag-modal>
  </div>
</template>

<script>
import { getAccuserAll } from '@/server/api'
import { userAdd, userCom, userGrounp } from '@/server/user'
import Validator from "@/assets/js/yz.js"
export default {
  data() {
    return {
      accuserList: [],
      comList: [],
      visible: false,
      user_group: [],
      form: {
        phone: '',
        user_group_id: '',
        accuser: ['-1'],
        // title: '',
        uname: '',
        password: '',
        audit: true,
        is_inner_user: true,
      },
      rules: {
        // group: { required: true, message: '请选择权限', trigger: 'change', validator: this.arrayValidator },
        user_group_id: [{ required: true, trigger: 'change' }],  //
        phone: [{ required: true, trigger: 'blur', validator: Validator.tels }],  //
        title: {
          required: true,
          message: '请选择所属公司',
          trigger: 'blur'
        },
        uname: {
          required: true,
          message: '请设置账号名称',
          trigger: 'blur'
        },
        password: {
          message: '请设置密码',
          trigger: 'blur',
          validator: this.passwordValidator,
        },
      },
    }
  },
  created() {
    this.getAccuser()
    this.handleSearch()
    userGrounp('index').then((res) => {
      this.user_group = res.list;
    })
  },
  methods: {
    handleSearch(val) {
      userCom({
        title: val
      }).then((e) => {
        this.comList = e.list
      })
    },
    accuserChange(val) {
      if (val.length === 0) {
        this.form.accuser_rule = 1
        this.form.accuser = ['']
      }
    },
    getAccuser() {
      getAccuserAll().then((res) => {
        this.accuserList = res.list
      })
    },
    passwordValidator(rule, value, callback) {
      if (
        (value == '' || value == null || value == undefined) &&
        this.id === ''
      ) {
        return callback(new Error(rule.message))
      }
      callback()
    },
    accuserSelect(val) {
      if (val === '-1') {
        this.form.accuser = ['-1']
      } else {
        this.form.accuser = this.form.accuser.filter((ele) => {
          return ele !== '-1'
        })
      }
    },
    onSubmit() {
      this.$refs.addForm.validate((valid) => {
        let form = JSON.parse(JSON.stringify(this.form))
        form.audit = form.audit ? 1 : 0
        form.is_inner_user = form.is_inner_user ? 1 : 0
        if (form.accuser[0] == '-1') {
          form.accuser = this.accuserList.map((ele) => {
            return ele.id
          })
        }
        if (valid) {
          userAdd(form).then((res) => {
            this.$message.success({
              content: '添加成功'
            })
            this.cancel()
            this.$router.push({ path: '/account/edit', query: { id: res.user_id } })
          })
        }
      })
    },
    cancel() {
      this.visible = false
      this.$refs.addForm.resetFields()
    },
  },
}
</script>
